import { Flex, HStack, Text, VStack } from "@chakra-ui/react";
import { useSearchParams } from "react-router-dom";
import { useState } from "react";
import styled from "styled-components";
import { CustomersDropDown } from "../components/CustomersDropdown";
import { TimeReportRow } from "../components/TimeReportRow";
import { LoggedInLayout } from "../components/layouts/LoggedInLayout";
import { PageTitle } from "../components/text/PageTitle";
import { useCustomerUsersCustomers, useTimeReports, useUpdateTimeReport } from "@api/hooks";
import { OoJobService } from "../networking/generated/api-client";
import { formatStartEnd } from "@utils/utils";

const TimeReportsPage = () => {
	const [selectedCustomer, setSelectedCustomer] = useState("");
	const [searchParams] = useSearchParams();
	const jobId = searchParams.get("id") || "";

	// API hooks
	const { customers } = useCustomerUsersCustomers();
	const { data: timeReports, isLoading } = useTimeReports(selectedCustomer, jobId);
	const { mutate } = useUpdateTimeReport();


	const [timeReportsExpanded, setTimeReportsExpanded] = useState<string[]>([]);
	const handleOnClick = (timeReportId: string) => {
		{
			if (!timeReportsExpanded.includes(timeReportId)) {
				const updatedExpandedArr = [...timeReportsExpanded];
				updatedExpandedArr.push(timeReportId);

				setTimeReportsExpanded(updatedExpandedArr);
			} else {
				const filteredData = timeReportsExpanded.filter((item) => item !== timeReportId);
				setTimeReportsExpanded(filteredData);
			}
		}
	};

	async function handleUpdateTimereport(
		entryId: string,
		status: OoJobService.PutTimereportEntryIdRequest["status"],
		declineComment?: OoJobService.PutTimereportEntryIdRequest["declineComment"]
	) {
		if (status) {
			try {
				await mutate({ entryId, body: { status, declineComment } });
			} catch (err) {}
		}
	}

	return (
		<LoggedInLayout width="s">
			<Styles>
				<VStack spacing={"2.5rem"} align="flex-start">
					<PageTitle loading={isLoading}>Tidrapporter</PageTitle>

					{customers && customers.customers && customers.customers.length > 1 && (
						<Flex align={"center"}>
							<CustomersDropDown value={selectedCustomer} onChange={setSelectedCustomer} className="select-customer" />
						</Flex>
					)}

					{timeReports?.map((item, index: number) => {
						return (
							item && (
								<div className={`section ${index === 0 ? "section-first" : ""}`} key={index}>
									<HStack>
										<Text fontSize={"xl"} fontWeight={"bold"}>
											{"Vecka " + item.weekNo + (item.year !== new Date().getFullYear() ? ", " + item.year : "")}
										</Text>
										<Text fontSize={"xl"}>{formatStartEnd(item.start!, item.end!)}</Text>
									</HStack>

									{item.dates
										.flatMap((d) => d.timeReports)
										.map((timeReport) => (
											<TimeReportRow
												key={timeReport.id}
												timeReport={timeReport}
												isExpanded={timeReportsExpanded.includes(timeReport.id)}
												onRowClick={() => handleOnClick(timeReport.id)}
												onUpdateTimereport={(status, declineComment) =>
													handleUpdateTimereport(timeReport.id, status, declineComment)
												}
											/>
										))}
								</div>
							)
						);
					})}
				</VStack>
			</Styles>
		</LoggedInLayout>
	);
};

export default TimeReportsPage;

const Styles = styled.div`
	display: flex;
	flex-direction: column;
	padding-bottom: 5rem;

	.section {
		width: 100%;
		/* padding-top: 2rem; */
	}

	.info {
		width: 100%;
		padding: 0 5px 12px 5px;
		border-bottom: 2px solid ${(props) => props.theme.colors.divider};

		/* .title {
      font-size: 20px;
      font-weight: 600;
    }

    .subtitle {
      margin-top: 4px;
      font-size: 16px;
      color: ${(props) => props.theme.colors.textDimmed};
    } */

		.text {
			font-size: 16px;
			font-weight: 400;
			line-height: 19px;
			margin: 5px 0;
		}
	}

	.select-customer {
		width: 312px;
	}
`;
